import { ICustomerBasic } from "../../Models/Customer";
import { TStore } from "../../hooks/useService";
import { POST, respond } from "../Helpers";
import {
  TCreateCustomerParam,
  TCreateCustomerService,
  TCreateOrUpdateAddressService,
  TCustomerKYCRes,
  TFetchCityStateFromMTSService,
  TFetchPanResponse,
  TFetchStateCityFromMTS,
  TGetCustomerAddressesData,
  TGetCustomerAddressesService,
  TGetCustomerData,
  TGetCustomerService,
  TGetCustomersCountData,
  TGetCustomersCountService,
  TGetCustomersData,
  TGetCustomersService,
  TGetEmployeesCountData,
  TGetEmployeesCountService,
  TGetEmployeesData,
  TGetEmployeesService,
  TRefreshEmployeeData,
  TRefreshEmployeesService,
  TSearchCustomersData,
  TSearchCustomersService,
  TSendOtpForCustomerService,
  TSendOtpForEmployeeValidationData,
  TSendOtpForEmployeeValidationService,
  TUpdateCustomerKYCService,
  TUpdateCustomerService,
  TUpdatePurityVerificationChargesData,
  TUpdatePurityVerificationChargesService,
  TVerifyOtpForCustomerData,
  TVerifyOtpForCustomerService,
  TVerifyOtpForEmployeeValidationData,
  TVerifyOtpForEmployeeValidationService,
  TVerifyOtpForUpdateMobileData,
  TVerifyOtpForUpdateMobileService,
  TcreateOrUpdateAddressParams,
} from "./types";

export const sendOtpForCustomer: TSendOtpForCustomerService = ({
  mobileNumber, email
}) => {
  return async (store: TStore) => {
    const { error } = await POST("/sendOtpForCustomer", { mobileNumber, email }, true);

    if (error === null) return respond({ sent: true }, null);
    else return respond(null, error);
  };
};

export const verifyOtpForCustomer: TVerifyOtpForCustomerService = (params) => {
  return async (store: TStore) => {
    const { setMobileVerificationId, setCustomerConfig } = store.customerStore;
    const { phone, otp } = params;
    const body = { mobileNumber: phone, otp };

    const { data, error } = await POST<TVerifyOtpForCustomerData>(
      "/verifyOtpForCustomer",
      body,
      true
    );
    if (data !== null) {
      setMobileVerificationId(data.mobileVerificationId);
      setCustomerConfig({ mobileNumber: phone } as ICustomerBasic);
    }

    return respond(data, error);
  };
};

export const verifyOtpForUpdateMobile: TVerifyOtpForUpdateMobileService = (
  params
) => {
  return async (store: TStore) => {
    const { mobileNumber, otp, customerRefNo } = params;
    const body = { mobileNumber, otp, customerRefNo };

    const { data, error } = await POST<TVerifyOtpForUpdateMobileData>(
      "/verifyOtpForUpdateMobile",
      body,
      true
    );
    return respond(data, error);
  };
};

export const getCustomers: TGetCustomersService = (params) => {
  return async (store: TStore) => {
    const { setCustomers } = store.customerStore;
    const { data, error } = await POST<TGetCustomersData>("/getCustomers", params, true);
    if (data !== null) setCustomers(data);
    return respond(data, error);
  };
};

export const getCustomersCount: TGetCustomersCountService = (params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TGetCustomersCountData>("/getCustomersCount", params, true);
    return respond(data, error);
  };
};

export const searchCustomers: TSearchCustomersService = (params) => {
  return async (store: TStore) => {
    const { setCustomers } = store.customerStore;
    const { data, error } = await POST<TSearchCustomersData>(
      "/searchCustomers",
      params,
      true
    );
    if (data !== null) {
      setCustomers(data)
    }
    return respond(data, error);
  };
};

export const createCustomer: TCreateCustomerService = (params) => {
  return async (store: TStore) => {
    params.isCorporate = params.isCorporate ? "Y" : "N";
    params.sendPromotions = params.sendPromotions ? "Y" : "N";
    const { data, error } = await POST<TCreateCustomerParam>(
      "/createCustomer",
      params,
      true
    );
    return respond(data, error);
  };
};

export const updateCustomer: TUpdateCustomerService = ({
  customer,
  customerRefNo,
  updateReqFromTransaction
}) => {
  return async (store: TStore) => {
    const isCorporate = customer.isCorporate ? "Y" : "N";
    const sendPromotions = customer.sendPromotions ? "Y" : "N";
    const { data, error } = await POST<TCreateCustomerParam>(
      "/updateCustomer",
      { customer: { ...customer, isCorporate, sendPromotions }, customerRefNo, updateReqFromTransaction },
      true
    );
    return respond(data, error);
  };
};

export const updatePurityVerificationCharges: TUpdatePurityVerificationChargesService = (params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TUpdatePurityVerificationChargesData>(
      "/updatePurityVerificationCharges",
      { ...params },
      true
    );
    return respond(data, error);
  };
};

export const getCustomer: TGetCustomerService = ({ customerRefNo }) => {
  return async (store: TStore) => {
    const { setCustomerConfig, setCustomerAddresses, setCustomerNominee } =
      store.customerStore;

    const { data, error } = await POST<TGetCustomerData>(
      "/getCustomer",
      { customerRefNo },
      true
    );

    if (data !== null) {
      const { addresses, nominee, ...basicDetails } = data;
      setCustomerAddresses(addresses);
      if (nominee) setCustomerNominee(nominee);
      const sendPromotions = basicDetails.sendPromotions === "Y";
       setCustomerConfig ({ ...basicDetails, sendPromotions, });
      //  setCustomerConfig(basicDetails as ICustomerBasic)
      //  setCustomerAddresses(addresses);
    } else {
      setCustomerAddresses([]);
    }
    return respond(data, error);
  };
};

export const validateKYC: TUpdateCustomerKYCService = (params) => {

  return async () => {
    const { data, error } = await POST<TCustomerKYCRes>(
      "/validateKYC",
      params,
      true
    );
    return respond(data, error);
  };
};

export const validateKYCAndUpdate: TUpdateCustomerKYCService = (params) => {
  return async () => {
    const { data, error } = await POST<TCustomerKYCRes>(
      "/validateKYCAndUpdate",
      params,
      true
    );
    return respond(data, error);
  };
};


export const getCustomerActiveAddresses: TGetCustomerAddressesService = (params) => {
  return async (store: TStore) => {
    const { setCustomerAddresses } = store.customerStore;

    const { data, error } = await POST<TGetCustomerAddressesData>(
      "/getActiveAddresses",
      { ...params },
      true
    );

    if (data !== null) setCustomerAddresses(data);
    else setCustomerAddresses([])
    return respond(data, error);
  };
};

export const createOrUpdateAddress: TCreateOrUpdateAddressService = (params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TcreateOrUpdateAddressParams>(
      "/createOrUpdateAddress",
      params,
      true
    );
    return respond(data, error);
  };
};
export const getCityStateFromMts: TFetchCityStateFromMTSService = (...params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TFetchStateCityFromMTS>(
      "/getStateCityFromMts",
      params,
      true
    );
    return respond(data, error);
  };
};

export const sendOtpForEmployeeValidation: TSendOtpForEmployeeValidationService = ({ dgCustomerRefNo }) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TSendOtpForEmployeeValidationData>("/sendOtpForEmployeeValidation", { dgCustomerRefNo }, true);

    if (error === null) return respond(data, null);
    else return respond(null, error);
  };
};

export const verifyOtpForEmployeeValidation: TVerifyOtpForEmployeeValidationService = ({ otp, mobileNumber }) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TVerifyOtpForEmployeeValidationData>("/verifyOtpForEmployeeValidation", { otp, mobileNumber }, true);

    if (error === null) return respond(data, null);
    else return respond(null, error);
  };
};

export const getEmployees: TGetEmployeesService = ({ pageNumber, pageSize, key }) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TGetEmployeesData>("/getEmployees", { pageNumber, pageSize, key }, true);
    const { setEmployees } = store.employeeStore;
    if (data !== null) setEmployees(data);
    return respond(data, error);
  };
}

export const getEmployeesCount: TGetEmployeesCountService = (params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TGetEmployeesCountData>("/getEmployeesCount", params, true);
    return respond(data, error);
  };
};

export const refreshEmployees: TRefreshEmployeesService = (params) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TRefreshEmployeeData>("/refreshEmployees", params, true);
    return respond(data, error);
  }
}

export const fetchCustomerPan = (dgCustomerRefNo: string) => {
  return async (store: TStore) => {
    const { data, error } = await POST<TFetchPanResponse>("/fetchCustomerPan", { dgCustomerRefNo }, true);
    return respond(data, error);
  };
};
